import React from 'react';
import { Users, Zap } from 'lucide-react';

const BrandTheme = () => {
  return (
    <section id="brand-theme" className="section-padding bg-white">
      <div className="container-center">
        {/* Section Header */}
        <div className="text-center space-y-6 mb-16 animate-slide-up">
          <h2 className="font-display text-4xl lg:text-5xl font-bold text-olive-brown">
            Why "FractionalVa"?
          </h2>
        </div>

        {/* Content */}
        <div className="max-w-4xl mx-auto space-y-12">
          <div className="grid md:grid-cols-2 gap-12 items-center">
            <div className="space-y-8">
              <div className="flex items-start space-x-4">
                <div className="p-3 bg-burnt-orange/20 rounded-full mt-1">
                  <Users className="h-6 w-6 text-burnt-orange" />
                </div>
                <div>
                  <h3 className="text-xl font-semibold text-olive-brown mb-3">Fractional</h3>
                  <p className="text-olive-brown/70 leading-relaxed">
                    means you get high-level support without the weight of a full-time hire.
                  </p>
                </div>
              </div>
              
              <div className="flex items-start space-x-4">
                <div className="p-3 bg-burnt-orange/20 rounded-full mt-1">
                  <Zap className="h-6 w-6 text-burnt-orange" />
                </div>
                <div>
                  <h3 className="text-xl font-semibold text-olive-brown mb-3">VA</h3>
                  <p className="text-olive-brown/70 leading-relaxed">
                    means you get a dependable operator who handles the details and keeps things moving.
                  </p>
                </div>
              </div>
            </div>
            
            {/* Visual Element */}
            <div className="relative">
              <div className="bg-gradient-to-br from-burnt-orange/10 to-olive-brown/10 rounded-3xl p-8">
                <div className="text-center space-y-6">
                  <div className="w-20 h-20 bg-burnt-orange/20 rounded-full flex items-center justify-center mx-auto">
                    <Users className="h-10 w-10 text-burnt-orange" />
                  </div>
                  <h3 className="text-2xl font-bold text-olive-brown">High-Level Support</h3>
                  <p className="text-olive-brown/70">Without the overhead</p>
                </div>
              </div>
            </div>
          </div>
          
          {/* Closer Line */}
          <div className="text-center pt-8 border-t border-olive-brown/20">
            <p className="text-xl font-medium text-olive-brown max-w-3xl mx-auto">
              You don't need more hustle. You need a system—and someone who runs it with you.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default BrandTheme;